import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import API_BASE_URL from '../../Config';

export default function CompraAdmin() {
  const [proveedores, setProveedores] = useState([]);
  const [productos, setProductos] = useState([]);
  const [form, setForm] = useState({
    numeroFactura: '',
    fecha: '',
    montoTotal: '',
    proveedorId: ''
  });
  const [productoTemp, setProductoTemp] = useState({ codigo: '', nombre: '', cantidad: '', precio: '' });

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/proveedores`)
      .then(res => setProveedores(res.data))
      .catch(err => console.error(err));
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleProductoChange = e => {
    setProductoTemp({ ...productoTemp, [e.target.name]: e.target.value });
  };

  const agregarProducto = () => {
    setProductos([...productos, productoTemp]);
    setProductoTemp({ codigo: '', nombre: '', cantidad: '', precio: '' });
  };

  const guardarCompra = async () => {
    const total = productos.reduce((acc, p) => acc + (Number(p.precio) * Number(p.cantidad)), 0);

    const compra = {
      numeroFactura: form.numeroFactura,
      fecha: form.fecha,
      montoTotal: total,
      proveedor: { id: Number(form.proveedorId) },
      productos: productos.map(p => ({
        codigo: p.codigo,
        nombre: p.nombre,
        cantidad: Number(p.cantidad),
        precio: Number(p.precio)
      }))
    };

    await axios.post(`${API_BASE_URL}/api/compras`, compra);
    alert('✅ Compra registrada');
    setForm({ numeroFactura: '', fecha: '', montoTotal: '', proveedorId: '' });
    setProductos([]);
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Registrar Compra</h2>

      <div className="grid grid-cols-2 gap-4 mb-6">
        <input name="numeroFactura" value={form.numeroFactura} onChange={handleChange} placeholder="N° Factura" className="border p-2 rounded" />
        <input name="fecha" type="date" value={form.fecha} onChange={handleChange} className="border p-2 rounded" />
        <select name="proveedorId" value={form.proveedorId} onChange={handleChange} className="border p-2 rounded">
          <option value="">Seleccionar proveedor</option>
          {proveedores.map(p => (
            <option key={p.id} value={p.id}>{p.nombre}</option>
          ))}
        </select>
      </div>

      <h3 className="text-lg font-semibold mb-2">Agregar productos</h3>
      <div className="grid grid-cols-4 gap-4 mb-2">
        {['codigo', 'nombre', 'cantidad', 'precio'].map(f => (
          <input
            key={f}
            name={f}
            placeholder={f}
            value={productoTemp[f]}
            onChange={handleProductoChange}
            className="border p-2 rounded"
          />
        ))}
      </div>
      <Button onClick={agregarProducto}>➕ Agregar producto</Button>

      <table className="w-full mt-4 table-auto border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Código</th>
            <th className="border p-2">Nombre</th>
            <th className="border p-2">Cantidad</th>
            <th className="border p-2">Precio</th>
          </tr>
        </thead>
        <tbody>
          {productos.map((p, idx) => (
            <tr key={idx}>
              <td className="border p-2">{p.codigo}</td>
              <td className="border p-2">{p.nombre}</td>
              <td className="border p-2">{p.cantidad}</td>
              <td className="border p-2">{p.precio}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Button className="mt-4" onClick={guardarCompra}>
        💾 Guardar Compra
      </Button>
    </div>
  );
}
